import { useMutation } from "@apollo/client";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Modal } from "components/layouts";
import * as yup from "yup";
import { IssueForm } from "components/forms";
import { CREATE_ISSUE } from "./apollo";
import config from "config";


const validationSchema = yup.object().shape({
  issueBackground: yup.string().required('Required'),
  issueDetails: yup.string().required('Required'),
  issueApplication: yup.string().required('Required'),
  action: yup.string().required('Required'),
  expectation: yup.string().required('Required'),
  classification: yup.string().required('Required'),
  priority: yup.string().required('Required'),
});

export default function CreateIssueContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {

  const [createIssue] = useMutation(CREATE_ISSUE);

  const form = useFormik<any>({
    initialValues: {
      issueBackground: "",
      issueDetails: "",
      issueApplication: config.apollo.name,
      action: "",
      expectation: "",
      attachments: [],
      classification: "",
      priority: "",
      fullName: "",
      email: "",
      phoneNumber: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      await createIssue({
        variables: {
          ...values
        },
      }).then(({ data }) => {
        if (data?.createIssue?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Isssue Created Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not create Issue",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size={"4xl"}
      title='Add New Issue'
      description='Create a general issue'
      renderActions={() => (
        <button
          type='button'
          disabled={form.isSubmitting || !form.isValid}
          onClick={form.submitForm}
          className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-primary-400 disabled:cursor-not-allowed focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm'
        >
          {form.isSubmitting ? "Creating..." : "Create Issue"}
        </button>
      )}
    >
      <IssueForm form={form} />
    </Modal>
  );
}
